module.exports = __webpack_public_path__ + "img/00018.2514d801.webp";